import { ContactWidgetWebshop } from 'contact-widget/src/components/ContactWidgetWebshop';
import { OpeningTextWidgetWebshop } from 'opening-text-widget/src/components/OpeningTextWidgetWebshop';
import { GalleryWidgetWebshop } from 'gallery-widget/src/components/GalleryWidgetWebshop';
import { TextWithContentWebshop } from 'text-with-content-widget/src/components/TextWithContentWebshop';
import { PackagesWidgetWebshop } from 'recommended-winepackages-widget/src/components/PackagesWidgetWebshop';
import { WinesWidgetWebshop } from 'recommended-wines-widget/src/components/WinesWidgetWebshop';
import { CarouselWidgetWebshop } from 'carousel-widget/src/components/CarouselWidgetWebshop';
import { SubscribeWidgetWebshop } from 'subscribe-widget/src/components/SubscribeWidgetWebshop';

const useWebshopWidgetDictionary = () => {
  const WebshopWidgets = {
    CONTACT: ContactWidgetWebshop,
    OPENINGTEXT: OpeningTextWidgetWebshop,
    GALLERY: GalleryWidgetWebshop,
    TEXTWITHCONTENT: TextWithContentWebshop,
    RECOMMENDEDPACKAGES: PackagesWidgetWebshop,
    RECOMMENDEDWINES: WinesWidgetWebshop,
    CAROUSEL: CarouselWidgetWebshop,
    SUBSCRIBE: SubscribeWidgetWebshop
  };

  const getWebshopWidgetsByType = (type: string): (() => JSX.Element) => {
    // Get the component from the dictionary
    // @ts-ignore
    const webshopWidget = WebshopWidgets[type];

    return webshopWidget;
  };

  return { getWebshopWidgetsByType };
};

export default useWebshopWidgetDictionary;
